import React, { useState, useEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Alert from "@material-ui/lab/Alert";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DeleteIcon from "@material-ui/icons/Delete";

const FileUploader = ({ className, onChange }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [file, setFile] = useState(null);
  const [inDropZone, setInDropZone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    onChange(file);
  }, [file, onChange]);

  const handleDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(true);
  };

  const handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(false);
  };

  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(true);
  };

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(false);

    handleAdd(e.dataTransfer.files);
  };

  const handleAdd = files => {
    if (files && files.length > 0) {
      if (files[0].type.startsWith("image/") || files[0].type === "application/pdf") {
        setError("");
        const meta = files[0].name.split(".");
        const extension = meta[meta.length - 1];
        const name = meta.slice(0, meta.length - 1).join(".");

        setFile({
          name,
          extension,
          data: files[0]
        });
      } else {
        setError("Formato de archivo inválido. Solo se permiten imágenes y pdf.");
      }
    }
  };

  return (
    <div className={className}>
      <input
        accept="image/*, application/pdf"
        multiple
        style={{ display: "none" }}
        id="upload-file"
        type="file"
        onChange={({ target }) => handleAdd(target.files)}
      />

      <label
        htmlFor="upload-file"
        className={inDropZone ? "upload-container inside-drag-area" : "upload-container"}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      >
        <AddAPhotoIcon fontSize="large" />

        <Typography className="ml-2 mr-2" variant="body2" align="center">
          {isMobile
            ? "Haga click para subir un archivo"
            : "Haga click o arrastre y suelte para subir un archivo"}
        </Typography>
      </label>

      <div className="mt-3">
        {error && <Alert severity="error">{error}</Alert>}

        {file && (
          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar className="with-background">
                  {file.type === "application/pdf" ? <PictureAsPdfIcon /> : <PhotoLibraryIcon />}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={file.name} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => setFile(null)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        )}
      </div>
    </div>
  );
};

export default FileUploader;
